export function toDateInputValue(date: Date) {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function daysAgo(days: number) {
  const date = new Date();
  date.setDate(date.getDate() - days + 1);
  return date;
}

export function defaultDateRangeLastDays(days: number) {
  return {
    from: toDateInputValue(daysAgo(days)),
    to: toDateInputValue(new Date()),
  };
}

/** Matches export API: end date is inclusive (next day sent to API). */
export function dateRangeToApiFilters(from: string, to: string) {
  const toDate = new Date(to);
  toDate.setDate(toDate.getDate() + 1);
  const fromDate = new Date(from);
  return {
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
  };
}
